import React, { Component } from 'react';
import { BrowserRouter as Router, Link, Route, Redirect } from 'react-router-dom';
import firebase, { auth, provider } from './firebase.js';
import Feed from './Feed';
import Status from './Status';
import Nav from './Nav';
import Menu from './Menu';
import UsersList from './UsersList';
import Info from './Info';
import './App.css';

class App extends Component {
	constructor() {
		super();
		this.state = {
			users: [],
			dragging: false,
			uploading: false,
			isLoggedIn: false,
			touchDevice: false
		}
		this.counter = 0;
		console.log(React.version);
	}

	componentDidMount() {
		auth.onAuthStateChanged(user => {
			this.setState({
				user: user,
				isLoggedIn: user !== null
			});
		});

		firebase.database().ref('users/').on('value', snapshot => {
			this.setState({
				users: Object.values(snapshot.val())
			});
		});

		window.addEventListener('paste', this.handlePaste);
		window.addEventListener('dragstart', this.handleDragStart);
		window.addEventListener('dragenter', this.handleDragEnter);
		window.addEventListener('dragover', this.handleDragOver);
		window.addEventListener('drop', this.handleDrop);
		window.addEventListener('dragend', this.handleDragEnd);
		window.addEventListener('dragexit', this.handleDragExit);
		window.addEventListener('dragleave', this.handleDragLeave);
		window.addEventListener('touchstart', this.handleTouchStart);
	}

	componentWillUnmount() {
		window.removeEventListener('paste', this.handlePaste);
		window.removeEventListener('dragstart', this.handleDragStart);
		window.removeEventListener('dragenter', this.handleDragEnter);
		window.removeEventListener('dragover', this.handleDragOver);
		window.removeEventListener('drop', this.handleDrop);
		window.removeEventListener('dragend', this.handleDragEnd);
		window.removeEventListener('dragexit', this.handleDragExit);
		window.removeEventListener('dragleave', this.handleDragLeave);
		window.removeEventListener('touchstart', this.handleTouchStart);
	}

	login = (e) => {
		auth.signInWithPopup(provider).then(result => {
			const user = result.user;
			firebase.database().ref('users/' + user.uid).update({
				displayName: user.displayName,
				photoURL: user.photoURL,
				uid: user.uid
			});
		});
	}

	logout = (e) => {
		auth.signOut();
	}

	getUsername = (uid) => {
		let displayName;
		firebase.database().ref('users/' + uid).on('value', snapshot => {
			displayName = snapshot.val() ? snapshot.val().displayName : "💀";
		});
		return displayName;
	}

	isAdmin = (uid) => {
		let isAdmin;
		firebase.database().ref('users/' + uid).on('value', snapshot => {
			isAdmin = snapshot.val().admin;
		});
		return isAdmin;
	}

	openFilePicker = (e) => {
		this.refs.fileInput.click();
	}

	handleFileChosen = (e) => {
		this.uploadImages(e.target.files);
	}

	handleDragStart = (e) => {
		if (!this.state.isLoggedIn) { return }
		e.preventDefault();
	}

	handleDragEnter = (e) => {
		if (!this.state.isLoggedIn) { return }
		e.preventDefault();
		this.setState({
			dragging: true
		});
		this.counter = this.counter + 1;
	}

	handleDragOver = (e) => {
		if (!this.state.isLoggedIn) { return }
		e.preventDefault();
	}

	handleDrop = (e) => {
		if (!this.state.isLoggedIn) { return }
		e.preventDefault();
		this.uploadImages(e.dataTransfer.files);
		this.counter = 0;
	}

	handleDragEnd = (e) => {
		if (!this.state.isLoggedIn) { return }
		e.preventDefault();

		this.setState({
			dragging: false
		});

		this.counter = 0;
	}

	handleDragExit = (e) => {
		if (!this.state.isLoggedIn) { return }
		e.preventDefault();

		this.setState({
			dragging: false
		});

		this.counter = 0;
	}

	handleDragLeave = (e) => {
		if (!this.state.isLoggedIn) { return }
		e.preventDefault();

		this.counter = this.counter - 1;
		if (this.counter === 0) {
			this.setState({
				dragging: false
			});
		}
	}

	handleTouchStart = (e) => {
		this.setState({
			touchDevice: true
		});
	}

	handlePaste = (e) => {
		if (!this.state.isLoggedIn) { return }
		let items = (e.clipboardData || e.originalEvent.clipboardData).items;
		let files = [];
		for (let index in items) {
			let item = items[index];
			if (item.kind === 'file') {
				let blob = item.getAsFile();
				files.push(blob);
			}
		}
		this.uploadImages(files);
	}

	generateThumbnail = (original, orientation) => {
		let canvas = document.createElement("canvas");
		let scale = Math.min((800 / original.width), (800 / original.height));
		let context = canvas.getContext("2d");
		let drawWidth = scale > 1 ? original.width : original.width * scale;
		let drawHeight = scale > 1 ? original.height : original.height * scale;

		if (4 < orientation && orientation < 9) {
			canvas.width = scale > 1 ? original.height : original.height * scale;
			canvas.height = scale > 1 ? original.width : original.width * scale;
	    } else {
			canvas.width = scale > 1 ? original.width : original.width * scale;
			canvas.height = scale > 1 ? original.height : original.height * scale;
	    }

		switch (orientation) {
			case 2: context.translate(canvas.width, 0); context.scale(-1, 1); break;
			case 3: context.translate(canvas.width, canvas.height); context.rotate(Math.PI); break;
			case 4: context.translate(0, canvas.height); context.scale(1, -1); break;
			case 5: context.rotate(0.5 * Math.PI); context.scale(1, -1); break;
			case 6: context.rotate(0.5 * Math.PI); context.translate(0, -canvas.width); break;
			case 7: context.rotate(0.5 * Math.PI); context.translate(canvas.height, -canvas.width); context.scale(-1, 1); break;
			case 8: context.rotate(-0.5 * Math.PI); context.translate(-canvas.height, 0); break;
			default: break;
		}

		context.drawImage(original, 0, 0, drawWidth, drawHeight);
		context.globalCompositeOperation = "destination-over";
		context.fillStyle = "#ffffff";
		context.fillRect(0, 0, drawWidth, drawHeight);

		return canvas.toDataURL('image/jpeg', 0.5);
	}

	getOrientation = (file, callback) => {
	    var reader = new FileReader();
	    reader.onload = function(e) {

	        var view = new DataView(e.target.result);
	        if (view.getUint16(0, false) !== 0xFFD8)
	        {
	            return callback(-2);
	        }
	        var length = view.byteLength, offset = 2;
	        while (offset < length)
	        {
	            if (view.getUint16(offset+2, false) <= 8) return callback(-1);
	            var marker = view.getUint16(offset, false);
	            offset += 2;
	            if (marker === 0xFFE1)
	            {
	                if (view.getUint32(offset += 2, false) !== 0x45786966) 
	                {
	                    return callback(-1);
	                }

	                var little = view.getUint16(offset += 6, false) === 0x4949;
	                offset += view.getUint32(offset + 4, little);
	                var tags = view.getUint16(offset, little);
	                offset += 2;
	                for (var i = 0; i < tags; i++)
	                {
	                    if (view.getUint16(offset + (i * 12), little) === 0x0112)
	                    {
	                        return callback(view.getUint16(offset + (i * 12) + 8, little));
	                    }
	                }
	            }
	            else if ((marker & 0xFF00) !== 0xFF00)
	            {
	                break;
	            }
	            else
	            {
	                offset += view.getUint16(offset, false);
	            }
	        }
	        return callback(-1);
	    };
	    reader.readAsArrayBuffer(file);
	}

	dataURItoBlob = (dataURI) => {
	  let byteString = atob(dataURI.split(',')[1]);
	  let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
	  let ab = new ArrayBuffer(byteString.length);
	  let ia = new Uint8Array(ab);

	  for (var i = 0; i < byteString.length; i++) {
	      ia[i] = byteString.charCodeAt(i);
	  }
	  let blob = new Blob([ab], {type: mimeString});
	  return blob;
	}

	uploadImages = (files) => {
		if (!this.state.isLoggedIn) { return }

		const images = Array.from(files).filter(function(file) {
			return (file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/gif");
		});

		images.forEach(file => {
			this.setState({
				uploading: true
			});

			let orient;
			this.getOrientation(file, function(orientation) {
		        orient = orientation;
		    });

			const push = firebase.database().ref('images/' + this.state.user.uid ).push();
			const newPostRef = firebase.database().ref('images/' + this.state.user.uid + '/' + push.key);
			const newFeedRef = firebase.database().ref('feed/' + push.key);

			const imageType = file.name.split('.').pop();
			const storageRef = firebase.storage().ref('users/' + this.state.user.uid + '/images/' + push.key + '.' + imageType);
			const thumbStorageRef = firebase.storage().ref('users/' + this.state.user.uid + '/images/' + push.key + '-thumb.jpg');

			let reader   = new FileReader();
			let img      = new Image();
			let object = {};
			let promise1;
			let promise2;

			object.uid = this.state.user.uid;
			object.name = this.getUsername(this.state.user.uid);

			let isGif = file.type === "image/gif";

			let uploadTask = storageRef.put(file);
			promise1 = new Promise((resolve, reject) => {
				uploadTask.on('state_changed', function(snapshot){
					if (snapshot.metadata) {
						object.time = snapshot.metadata.timeCreated;
					}
				}, function(error) {
					reject(error);
				    alert(error);
				}, function() {
					uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
						object.fullSizeUrl = downloadURL;
						resolve(downloadURL);
					});
				});
			});

			if (!isGif) {
				reader.onloadend = () => {
				    img.onload = function() {
					    let thumb = this.dataURItoBlob(this.generateThumbnail(img, orient));
					    let thumbUploadTask = thumbStorageRef.put(thumb);
					    promise2 = new Promise((resolve, reject) => {
							thumbUploadTask.on('state_changed', function(snapshot){
								if (snapshot.metadata) {
									object.time = snapshot.metadata.timeCreated;
								}
							}, function(error) {
								reject(error);
							    alert(error);
							}, function() {
								thumbUploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
									object.url = downloadURL;
									resolve(downloadURL);
								});
							});
						});
			    	}.bind(this);
			    	img.src = reader.result;
		    	}
		    	reader.readAsDataURL(file);
			}

			Promise.all([promise1, promise2]).then(values => {

				promise1.then(function(result) {
					object.fullSizeUrl = result;
					newFeedRef.update(object);
					newPostRef.update(object);
				});
				promise2.then(function(result) {
					object.url = result;
					newFeedRef.update(object);
					newPostRef.update(object);
				});

				if (images.indexOf(file) === (images.length -1)) {
					this.setState({ uploading: false });
				}
			});

		});

		this.setState({
			dragging: false
		});
	}

	render() {
		let userActions;
		let isAdmin;
		if (this.state.users && this.state.users.length) {
			if (this.state.isLoggedIn) {
				if (this.isAdmin(this.state.user.uid)) {
					isAdmin = true;
				}
				userActions =
					<div className="user-actions">
						<Link to={`/u/${this.state.user.uid}`}>Profile</Link>
						<input
							id="upload"
							ref="fileInput"
							type="file"
							accept="image/jpeg,image/png,image/gif"
							onChange={this.handleFileChosen}
							multiple
						/>
						<a onClick={this.openFilePicker}>Upload</a>
						<Menu
							isAdmin={isAdmin}
							authText={"Log Out"}
							auth={(e) => { if (window.confirm("Are you sure you want to log out?")) this.logout(e)}}
						/>
					</div>
			} else {
     		   	userActions =
					<div className="user-actions">
	     		   		<a className="highlight" onClick={this.login}>Log In / Sign Up</a>
	     		   		<Menu/>
	     		   	</div>
     		}
        }
		return <Router>
			<div
				id="app-wrapper"
				className={this.state.touchDevice ? "" : "no-touch"}
			>
				{this.state.dragging ? <Status status="Drop Photos" blink={true} /> : null }
				{this.state.uploading ? <Status status="Uploading..." blink={true} /> : null }
				{this.state.uploading ? <Redirect push to={`/u/${this.state.user.uid}`}/> : null}

				<Route path="/" exact={true} render={() =>
					<div id="home-page">
						<Nav userActions={userActions}/>
						<Feed
							path={'/featured'}
							isProfile={false}
						/>
					</div>
				}/>
				<Route path="/u/:uid" exact={true} render={({ match }) =>
					<div id="profile-page">
						<Nav userActions={userActions} title={this.getUsername(match.params.uid)}/>
						<Feed
							key={match.params.uid}
							path={'images/' + match.params.uid}
							uid={match.params.uid}
							isProfile={true}
						/>
					</div>
				}/>
				<Route path="/info" exact={true} render={() =>
					<div id="info-page">
						<Nav userActions={userActions} title={"Info"}/>
						<Info/>
					</div>
				}/>
				<Route path="/members" exact={true} render={() =>
					<div id="members-page">
						<Nav userActions={userActions} title={"Members"}/>
						<UsersList
							users={this.state.users}
						/>
					</div>
				}/>
				<Route path="/admin" exact={true} render={() =>
					<div id="admin">
						<Nav userActions={userActions} title={isAdmin ? "🔑" : "💀"}/>
						{isAdmin ? <Feed path={'/feed'} admin={true} isProfile={false}/> : null }
					</div>
				}/>
			</div>
		</Router>;
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js